import type { ButtonHTMLAttributes, ReactNode } from 'react'

import { Spinner } from '@/components/ui/Spinner'
import { COLORS } from '@/styles/colors'

import { OutlineButtonElement } from './styles'

export type OutlineButtonVariant = 'default' | 'danger'

interface OutlineButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  variant?: OutlineButtonVariant
  children: ReactNode
  /** 로딩 중 — 텍스트 대신 스피너(투명 배경이므로 variant 글자색). 클릭 차단. */
  loading?: boolean
}

const SPINNER_COLOR: Record<OutlineButtonVariant, string> = {
  default: COLORS.textPrimary,
  danger: COLORS.fgNegative,
}

export function OutlineButton({
  variant = 'default',
  children,
  type = 'button',
  loading = false,
  onClick,
  ...rest
}: OutlineButtonProps) {
  return (
    <OutlineButtonElement
      variant={variant}
      type={type}
      aria-busy={loading || undefined}
      onClick={loading ? undefined : onClick}
      {...rest}
    >
      {loading ? (
        <Spinner
          size='medium'
          color={SPINNER_COLOR[variant]}
        />
      ) : (
        children
      )}
    </OutlineButtonElement>
  )
}
